import { render } from "./GuestsNotesList.vue?vue&type=template&id=5dbe77d5&scoped=true"
import script from "./GuestsNotesList.vue?vue&type=script&lang=js"
export * from "./GuestsNotesList.vue?vue&type=script&lang=js"

import "./GuestsNotesList.vue?vue&type=style&index=0&id=5dbe77d5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dbe77d5"]])

export default __exports__